/**
 * @module views\sys\souce
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { Watch } from "vue-property-decorator";
import { MethodService } from "@/utils/serviceModel";

@Component
export default class Source extends GhBase {
  private args = { keyword: "" };

  private editCode(item) {
    this.navigate("/sys/source/editCode/editCode", item);
  }

  private codeOptions = {
    readOnly: false,
    language: "python",
    autoIndent: true
  };

  private saveCode(item) {
    if (item && item.Code) {
      let page = this.$refs.table as GhTablePage;
      if (page) {
        page.saveItem(item);
      }
    }
  }

  private async reCompile(item) {
    console.log(item);
    if (item.Id) {
      this.$setLoading(true);
      let args = { source_id: item.Id };
      await this.svRecompile.invokeAsyn(args);
      this.$setLoading(false);
    }
  }

  protected onNavigateTo(item) {
    if (item) {
      this.saveCode(item);
    }
  }

  created() {
    this.svRecompile = new MethodService(
      "mes.business.sys.source.dynamic",
      "DynamicService",
      "parse"
    );
  }

  private svRecompile: MethodService;
}
